import React, { forwardRef, useImperativeHandle, useRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  forwardRef?: React.RefObject<HTMLInputElement | null>;
  inputMode?: 'text' | 'tel' | 'numeric' | 'decimal' | 'email' | 'url' | 'search';
  autoComplete?: string;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  inputMode,
  autoComplete,
  ...props
}, ref) => {
  const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');
  const inputRef = useRef<HTMLInputElement>(null);
  
  // Expose the input ref to parent components
  useImperativeHandle(ref, () => inputRef.current as HTMLInputElement);
  
  return (
    <div className="input-group">
      {label && (
        <label htmlFor={inputId} className="input-label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`input ${error ? 'error' : ''} ${className}`}
        ref={inputRef}
        inputMode={inputMode}
        autoComplete={autoComplete}
        {...props}
      />
      {error && (
        <p className="input-error">{error}</p>
      )}
      {helperText && !error && (
        <p className="input-helper">{helperText}</p>
      )}
    </div>
  );
});
